import Model, { attr, belongsTo } from "@ember-data/model";
import type HealthCentre from "parog-web/models/health-centre";

/**
 * Read-only. A valid identity document of a health centre, loaded with
 * `loadValidIdentityDocuments` where the list is shown.
 * See docs/specs/features/valid-identity-documents.md.
 */
export default class ValidIdentityDocument extends Model {
  @attr("string") declare code: string;
  @belongsTo("health-centre", {
    async: false,
    inverse: "validIdentityDocuments"
  })
  declare healthCentre: HealthCentre;
  @attr("string") declare label: string;
  @attr("string") declare level: "high" | "low";
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "valid-identity-document": ValidIdentityDocument;
  }
}
